module.exports = __webpack_public_path__ + "img/people.246183bf.svg";